const CONFIG = {
  // API_BASE_URL: 'https://smartshrink-1.onrender.com/api',
  API_BASE_URL: 'https://smartshrinkai-dev.onrender.com/api',
  // API_BASE_URL: 'http://localhost:5000/api',
  TIMEOUT: 10000,
};

export default CONFIG;